import React from 'react'
import styled from 'styled-components'
import Icons from '../../components/Icons'

const ServiceCard = ({cardData, onClick, dataTestId}) => {
  const {imageUrl, title} = cardData

  const upperCaseTitle = title ? title.toUpperCase() : ''
  return (
    <Container
      onClick={() => onClick(cardData)}
      data-testid={dataTestId || 'service-card'}
    >
      <ImageContainer>
        {imageUrl ? (
          <StyledImage url={imageUrl} data-testid="service-card-image" />
        ) : (
          <StyledIcons>
            <Icons icon="DISCLOSE_ARROW" data-testid="service-card-icon" />
          </StyledIcons>
        )}
      </ImageContainer>
      <TitleContainer data-testid="service-card-title">
        {upperCaseTitle}
      </TitleContainer>
    </Container>
  )
}

export default ServiceCard

const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 685px;
  height: 120px;
  background: #ffffff;
  backdrop-filter: blur(4px);
  border-radius: 10px;
  cursor: pointer;

  @media (max-width: 1500px) {
    max-width: 560px;
  }

  @media (max-width: 1245px) {
    height: 100px;
    max-width: 450px;
  }

  @media (max-width: 1023px) {
    max-width: 700px;
  }

  @media (max-width: 780px) {
    max-width: 100%;
  }

  @media (max-width: 420px) {
    height: 80px;
  }
`
const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 170px;
  height: 100%;
  box-sizing: border-box;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;

  @media (max-width: 1235px) {
    width: 150px;
  }

  @media (max-width: 420px) {
    width: 120px;
  }
`

const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #000000;
  padding: 0 40px 0 40px;
  box-sizing: border-box;
  user-select: none;

  @media (max-width: 1235px) {
    padding: 0 35px 0 35px;
    font-size: 16px;
  }

  @media (max-width: 420px) {
    padding: 0 19px 0 19px;
    font-size: 13px;
  }
`
const StyledImage = styled.div`
  width: 170px;
  height: 100%;
  background-image: url('${props => props.url}');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
`

const StyledIcons = styled.div`
  width: 170px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
